interface ThemeBootstrap {
	readThemeMode(): string;
	resolveThemeMode(mode: string): ThemeResolution;
	syncBrowserChrome(mode: string): string;
	persistThemeMode(mode: string): boolean;
	commitThemeMode(mode: string, persist?: boolean): string;
}

interface ThemeResolution {
	mode: string;
	requestedMode: string;
	theme: string;
	background: string;
	colorScheme: string;
}

declare global {
	interface Window {
		DeepmoxThemeBootstrap?: ThemeBootstrap;
	}
}

export function readThemeMode(): string {
	try {
		return window.DeepmoxThemeBootstrap?.readThemeMode() ?? 'reader';
	} catch {
		return 'reader';
	}
}

export function resolveThemeMode(mode: string): ThemeResolution {
	try {
		const resolved = window.DeepmoxThemeBootstrap?.resolveThemeMode(mode);
		if (resolved) return resolved;
	} catch {
		// The bootstrap is optional in isolated tests and embedded documents.
	}
	const theme = document.documentElement.dataset.theme ?? 'reader';
	return {
		mode,
		requestedMode: mode,
		theme,
		background: getComputedStyle(document.documentElement).backgroundColor,
		colorScheme: theme === 'dark' ? 'dark' : 'light',
	};
}

export function commitThemeMode(mode: string): string {
	try {
		return window.DeepmoxThemeBootstrap?.commitThemeMode(mode, true) ?? 'reader';
	} catch {
		return 'reader';
	}
}

export function persistThemeMode(mode: string): boolean {
	try {
		return window.DeepmoxThemeBootstrap?.persistThemeMode(mode) ?? false;
	} catch {
		return false;
	}
}

export function syncBrowserChrome(mode: string): string {
	try {
		return window.DeepmoxThemeBootstrap?.syncBrowserChrome(mode) ?? 'reader';
	} catch {
		return 'reader';
	}
}
